import { Component } from '@angular/core';

@Component({
    selector: 'page-not-found',
    templateUrl: './page-not-found.html',
    styleUrls: ['page-not-found.scss'],
    standalone: false
})
export class PageNotFoundComponent {

  constructor() { };
}
